import React from 'react'
import { connect } from 'react-redux'


// Component Functions 
import * as ComponentFunctions from './PractitionerProtocolConsumptionDetails.Functions'
import PractitionerProtocolConsumptionListComponent from '../PractitionerConsumptionList/PractitionerProtocolConsumption.List.Component'
import PractitionerConsumptionSyncProcessComponent from '../PractitionerConsumptionSyncProcess/PractitionerConsumptionSyncProcess.Component'
import PractitionerConsumptionToSettleComponent from '../PractitionerConsumptionToSettle/PractitionerConsumptionToSettle.Component'
import { Separator } from '@fluentui/react'


const PractitionerProtocolConsumptionDetails = (props: ComponentFunctions.Props) => {
    const { practitioner, practitionerProtocols } = props

    return (
        <div className="PractitionerProtocolConsumptionDetails">
            {practitioner && <PractitionerConsumptionSyncProcessComponent PractitionerId={practitioner.userId} />}
            {practitioner && <PractitionerConsumptionToSettleComponent PractitionerId={practitioner.userId} status={6} />}
            {practitioner && <PractitionerProtocolConsumptionListComponent PractitionerId={practitioner?.userId} />}
        </div>
    )
}

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps,
) (PractitionerProtocolConsumptionDetails as any)